import { globalConstants } from "../constants/globalConstants";
import {
	getToken,
	removeItemFromLocalStorage,
	setItemToLocalStorage,
} from "../utils/local-storage.util";
import { returnLoggedUserComopanyId } from "../utils/permission/user";
import { api } from "../api";

/**
 * SET sleceted rows in global state
 *
 * @param {Array} selectedRows
 * @param {string} view - name of the list
 *
 */
export const setSelectedRows = ({ selectedRows, view }) => {
	return (dispatch) => {
		dispatch({
			type: globalConstants.SET_SELECTED_ROWS,
			data: { selectedRows: selectedRows, view: view },
		});
	};
};

/**
 * SET global CUSTOMER/RESELLER in state and local storage
 * @param {*} data
 * @returns
 */
export const setCustomer = (data, isReseller = false) => {
	return (dispatch) => {
		const key = isReseller ? "Reseller" : "Customer";
		if (!data) {
			removeItemFromLocalStorage(key);
		} else {
			setItemToLocalStorage(key, data);
		}

		if (isReseller) {
			dispatch({
				type: globalConstants.SET_GLOBAL_RESELLER,
				data,
			});
		} else {
			dispatch({
				type: globalConstants.SET_CUSTOMER,
				data,
			});
		}
	};
};

/**
 * Fetch the logged-in user's own company once (at bootstrap) and store the full
 * payload — including the `canConsumeCustom*` flags — in `global.ownCompany`.
 *
 * `global.customer` only holds the company id and the JWT does not carry the
 * flags, so this is the single source of truth for own-company permission
 * gating (e.g. hiding spec creation when `canConsumeCustomSpecifications` is
 * false). Fire-and-forget: silently no-ops without a company id, and on failure
 * leaves `ownCompany` null (hide-until-loaded keeps gated surfaces hidden).
 *
 * @returns {Function} thunk
 */
export const getOwnCompany = () => {
	return (dispatch) => {
		const companyId = returnLoggedUserComopanyId();
		if (!companyId) return;

		const requestOptions = {
			method: "GET",
			url: `/company/${companyId}`,
			headers: {
				Authorization: "Bearer " + getToken(),
			},
		};

		return api(requestOptions).then(
			(res) => {
				dispatch({
					type: globalConstants.SET_OWN_COMPANY,
					data: res.data.result,
				});
			},
			() => {
				// Non-fatal: gated surfaces stay hidden (hide-until-loaded).
			}
		);
	};
};

/**
 * SET room for global customer chat
 * @param {*} data
 * @returns
 */
export const setRoom = (data) => {
	return (dispatch) => {
		dispatch({
			type: globalConstants.SET_ROOM,
			data,
		});
	};
};
